import * as PIXI from 'pixi.js';
import FlashLib from "flashlib";
import GlobalDispatcher from "../../events/GlobalDispatcher";
import EntryPoint from "../../EntryPoint";

export default class BaseSlotReelsContainer extends FlashLib.MovieClip {
    constructor(data, displayItemData) {
        super(data, displayItemData);
        
        this.reels = [];
        this.reelsStarted = 0;
        this.data = EntryPoint.GameModel.reels;

        this.init();
        this.addListeners();
    }

    init() {
        let configData = EntryPoint.configData;
        let reelsConfig = configData.reels;

        let reel = null;
        for(let i = 1; i < reelsConfig.reelsCount + 1; i++) {
            reel = this.getChildByName('reel' + i);
            reel.setData(i, this.data[i - 1]);
            this.reels.push(reel);
        }
    }

    addListeners() {
        GlobalDispatcher.add('reel:stopped', this.onReelStopped, this);
        GlobalDispatcher.add('stateManager:changed', this.onStateChanged, this);
        GlobalDispatcher.add('linesContainer:slowWinLine', this.showWinningSymbols, this);
    }

    start() {
        this.reels.forEach((reel) => {
            reel.startReel();
            this.reelsStarted++;
        });
    }

    stop(data) {
        this.data = data;
        let delay = 0;
        let type = 'normal';
        this.reels.forEach((reel, index, arr) => {
            delay += EntryPoint.NearWinCalculator.checkForReel(index) !== -1 ? 2000 : (EntryPoint.GameSettings.quickSpin ? 0 : 500);
            setTimeout(() => {
                //reel.speedIndex = NearWinCalculator.nearReels.indexOf(index) !== -1 ? 5 : 1;
                type = EntryPoint.NearWinCalculator.checkForReel(index) ? 'nearWin' : 'normal';
                reel.stopReel(this.data[index], type);
            }, delay);
        });
    }

    showWinningSymbols(data) {
        this.hideWinningSymbols();
        data.params.path.forEach((pathData) => {
            this.reels[pathData[0]].startAnimationWinningSymbols(pathData[1]);
        });
    }

    hideWinningSymbols() {
        this.reels.forEach((reel)=>{
            reel.stopAnimationWinningSymbols();
        });
    }

    onReelStopped(event) {
        this.reelsStarted--;
        if (this.reelsStarted === 0) {
            GlobalDispatcher.dispatch('reelsContainer:reelsStopped');
        }
    }

    onStateChanged(data) {

    }

    setActive(value) {
        this.reels.forEach((reel)=>{
            reel.symbols.forEach((symbol)=>{
                symbol.setActive(value);
            });
            reel.activeReel = value;
        })
    }
}
//FlashLib.registerClass('BaseSlotReelsContainer', BaseSlotReelsContainer);